module.exports = "/_next/static/images/110053ee5756daba4ba4dd2cfa4402b1-image-right-lg.jpg";